import React from 'react'
import "./newsletter-responsive.css";

const Newsletter = () => {
    return (
        <div className="newsletter newsletter-clean d-none d-lg-block">
            <div className="container container-lg">
                <div className="newsletter-box newsletter-clean-box position-relative z-1">
                    <div className="row justify-content-center">
                        <div className="col-xl-8 col-lg-10">
                            <div className="newsletter-clean-content text-center">
                                <h2 className="newsletter-clean-title">
                                    Don&rsquo;t Miss Out On Grocery Deals
                                </h2>
                                <p className="newsletter-clean-subtitle">
                                    Sign up for the update newsletter
                                </p>
                                <form action="#" className="newsletter-clean-form position-relative">
                                    <label className="visually-hidden" htmlFor="newsletter-email">
                                        Email address for RGHT NOW updates
                                    </label>
                                    <input
                                        id="newsletter-email"
                                        type="text"
                                        className="form-control common-input rounded-pill text-white py-22 px-16 pe-144"
                                        placeholder="Your email address..."
                                        aria-label="Email address for RGHT NOW updates"
                                    />
                                    <button
                                        type="submit"
                                        className="btn btn-main-two rounded-pill position-absolute top-50 translate-middle-y inset-inline-end-0 me-10"
                                    >
                                        Subscribe
                                    </button>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    )
}

export default Newsletter
